import { startTransition, useCallback } from "react";
import { useNavigate, type NavigateOptions, type To } from "react-router";

export function useTransitionNavigate() {
  const navigate = useNavigate();
  return useCallback(
    (to: To, options?: NavigateOptions) => {
      startTransition(() => {
        navigate(to, options);
      });
    },
    [navigate]
  );
}
